import { CloseIcon } from "@chakra-ui/icons";
import {
    ButtonGroup,
    Drawer,
    DrawerContent,
    DrawerOverlay,
    IconButton,
    useDisclosure
} from "@chakra-ui/react";
import { FC, useEffect } from "react";
import { GrTestDesktop } from "react-icons/gr";
import { WishedTool } from "../../models/collaborate.model";
import ToolsOutput from "./ToolsOutput";

type ToolWishListOutputProps = {
    open: boolean;
    wishedTool: WishedTool;
    outputData?: {
        file: string;
        text: string | { complete_output: string; system_arguments: any };
    };
    onClose: () => void;
};

const ToolWishListOutput: FC<ToolWishListOutputProps> = (props) => {
    const toolTestDisc = useDisclosure();

    useEffect(() => {
        if (props.open) {
            toolTestDisc.onOpen();
        }
    }, [props.open, toolTestDisc]);

    const closeModalHandler = () => {
        if (typeof props.onClose === "function") {
            props.onClose();
        }
        toolTestDisc.onClose();
    };

    return props.outputData ? (
        <Drawer
            isOpen={toolTestDisc.isOpen}
            placement="right"
            size="sm"
            closeOnOverlayClick={false}
            onClose={closeModalHandler}
        >
            <DrawerOverlay />
            <DrawerContent style={{ maxWidth: "unset", display: "block", width: "600px" }}>
                {/* <DrawerCloseButton /> */}
                <div className="drawer-body h-full grid grid-rows-[60px_auto] overflow-hidden">
                    <div className="toolbar px-[16px] h-full border-b flex items-center justify-between gap-[10px] border-[#555555]">
                        <p className="text-[16px] flex items-center gap-1 font-bold">
                            <GrTestDesktop size={"15px"} />
                            Tools Lab
                        </p>
                        <ButtonGroup size="sm">
                            {/* <IconButton aria-label="Persist" title="Persist" icon={<VscSaveAll size="18px" />} /> */}
                            <IconButton
                                onClick={closeModalHandler}
                                variant={"outline"}
                                colorScheme="red"
                                title="Close"
                                aria-label="Close"
                                icon={<CloseIcon />}
                            />
                        </ButtonGroup>
                    </div>
                    <section className="output-container border-l px-[10px] py-[10px] w-full h-full overflow-hidden">
                        <ToolsOutput
                            outputData={props.outputData}
                            isExecuting={false}
                            toolName={props.wishedTool.title}
                        />
                    </section>
                </div>

                {/* <DrawerFooter>
                        <Button variant='outline' mr={3} onClick={toolTestDisc.onClose}>
                            Cancel
                        </Button>
                    </DrawerFooter> */}
            </DrawerContent>
        </Drawer>
    ) : (
        <></>
    );
};

export default ToolWishListOutput;
